import { z } from 'zod'

import type {
  CommonCloudFrontUrlResponse,
  CommonResponseListExamProblemWithProblemResponse,
  ExamScheduleResponse,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type ExamProblem,
  ExamProblemSchema,
  type ExamReportFile,
  ExamReportFileSchema,
  type ExamSchedule,
  ExamScheduleSchema,
} from './schemas'

const ENTITY = 'Exam'

// 생성 타입의 ExamProblemWithProblemResponse.problem 은 ProblemResponse 이름 충돌로 잡탕이다(문제 본체·학습지
// 필터 추천·그룹 성취도 중첩이 한 칸을 덮어쓴다). 실제로는 문제 본체 V1 이 온다. 스키마가 실제 모양을
// 검증하므로 입력은 생성 타입으로 받되 이 한 줄에서만 unknown 을 거친다.
// 2026-09-30 백엔드 develop 의 exam/controller/response/ExamProblemWithProblemResponse.kt 로 확인.
const asWire = (raw: CommonResponseListExamProblemWithProblemResponse['data']): unknown => raw

export const adaptExamProblems = (
  raw: CommonResponseListExamProblemWithProblemResponse['data'],
): ExamProblem[] => parseApiResponse(z.array(ExamProblemSchema), asWire(raw), ENTITY)

export const adaptExamSchedules = (raw: ExamScheduleResponse[]): ExamSchedule[] =>
  parseApiResponse(z.array(ExamScheduleSchema), raw, ENTITY)

export const adaptExamReportFile = (raw: CommonCloudFrontUrlResponse): ExamReportFile =>
  parseApiResponse(ExamReportFileSchema, raw, ENTITY)
